module.exports = __webpack_public_path__ + "static/img/wljy.7edde5d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wljy.png
// module id = FWr9
// module chunks = 1